var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentalwelness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H40C46.6274 0 52 5.37258 52 12V40C52 46.6274 46.6274 52 40 52H12C5.37258 52 0 46.6274 0 40V12Z",
    fill: "#E8F6EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0833 15.5C22.0004 15.5 20.9617 15.9302 20.196 16.696C19.4302 17.4618 19 18.5004 19 19.5833C18.021 19.7246 17.1265 20.2164 16.4828 20.9674C15.8391 21.7184 15.4899 22.6776 15.5 23.6667C15.4916 24.4468 15.7069 25.2131 16.1204 25.8747C16.5339 26.5364 17.1284 27.0657 17.8333 27.4V29.5C17.8333 30.4283 18.2021 31.3185 18.8585 31.9749C19.5148 32.6313 20.4051 33 21.3333 33H23.0833V15.5Z",
    strokeWidth: 2.21667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#15804C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.916 15.5C29.999 15.5 31.0376 15.9302 31.8034 16.696C32.5691 17.4618 32.9993 18.5004 32.9993 19.5833C33.9784 19.7246 34.8728 20.2164 35.5165 20.9674C36.1603 21.7184 36.5095 22.6776 36.4993 23.6667C36.5077 24.4468 36.2924 25.2131 35.8789 25.8747C35.4654 26.5364 34.871 27.0657 34.166 27.4V29.5C34.166 30.4283 33.7973 31.3185 33.1409 31.9749C32.4845 32.6313 31.5943 33 30.666 33H28.916V15.5Z",
    strokeWidth: 2.21667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#15804C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalwelness);
export default __webpack_public_path__ + "static/media/mental welness.d31786010f792d19f1eb4f61f4b54523.svg";
export { ForwardRef as ReactComponent };